import * as actions from "../action.constants";

const initialState = {
  webhooksListData: {},
  webhookDeliverLogsData: {},
};

const saveWebhooks = (state, action) => {
  return {
    ...state,
    webhooksListData: action.payload || {},
  };
};

const saveWebhookDeliveryLogs = (state, action) => {
  return {
    ...state,
    webhookDeliverLogsData: action.payload || {},
  };
};

const handlers = {
  [actions.SAVE_WEBHOOKS]: saveWebhooks,
  [actions.SAVE_WEBHOOK_DELIVERY_LOGS]: saveWebhookDeliveryLogs,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
